var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"apply-theme",rawName:"v-apply-theme"}],staticClass:"checkout-app",class:{ mobile: _vm.isMobile(), ...(_vm.config.appClass || {}) }},[_c('CheckoutHeader',{key:_vm.headerKey}),_c('router-view',{on:{"onError":_vm.errorHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }